import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

/* ============================================================
   <SEO />
   ------------------------------------------------------------
   Single-purpose head tag manager for the SPA. Injects a unique
   <title>, <meta description>, canonical URL, OG + Twitter cards
   per route so Google indexes each page correctly.

   Only accepts the fields we actually vary per page. Everything
   else (favicons, twitter site handle, etc.) stays in public/index.html.
   ============================================================ */

const SITE = 'https://n3uro.world';
const SITE_NAME = 'N3URO WORLD®';
const CARD = (p) => `${process.env.REACT_APP_BACKEND_URL}/api/share/page.jpg?p=${encodeURIComponent(p)}`;

const SEO = ({
  title,
  description,
  path,
  canonical,
  image,
  noindex = false,
}) => {
  const pagePath = path || canonical || '/';
  const url = `${SITE}${pagePath}`;
  const img = image || CARD(pagePath);
  const fullTitle = !title
    ? `${SITE_NAME} | Neuro-Inclusive Family Infrastructure`
    : title.includes(SITE_NAME)
      ? title
      : `${title} | ${SITE_NAME}`;

  // Drop index.html's static fallback tags so each route exposes a single canonical/OG set.
  useEffect(() => {
    document.querySelectorAll('head [data-static-seo]').forEach((el) => el.remove());
  }, []);

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow, max-snippet:-1, max-image-preview:large'} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={img} />
      <meta property="og:image:secure_url" content={img} />
      <meta property="og:image:alt" content={`${fullTitle} share card`} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_GB" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
};

export default SEO;
